import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import { useOrganizations } from "@/store/organizations";
import { type Organizations, type DataInstance } from "@/platform-data";
import FilterSection from "@/components/filter-section.vue"
import elasticlunr, { SearchResults, Index } from 'elasticlunr';
import { debounce, filter } from "lodash-es";
import { onMounted } from "vue";

import {filterOrganizations, type SelectedFilters, filtersBase } from "@/util/chart-utils";

type Props = {
	selectedFilters: SelectedFilters,
	showFilters: boolean,
	showLocation: boolean,
}



export default /*#__PURE__*/_defineComponent({
  __name: 'filters',
  props: {
    selectedFilters: {},
    showFilters: { type: Boolean },
    showLocation: { type: Boolean }
  },
  emits: ['update:filtersChange','update:clearFilters',"update:showFilters"],
  setup(__props: any, { expose: __expose, emit }) {
  __expose();

const props = __props;

const compareOrg = ref(false);

const organizations = useOrganizations();
const showLocation = ref(false);
const selectedFilters = computed(()=>props.selectedFilters);
const showFilters = computed(()=>props.showFilters);





const handleClearFilters = (e: any) => {
	showLocation.value = false;
	emit('update:clearFilters', e)
}
const handleClick = (e: any) => {
	emit('update:filtersChange', e)
}

function handleFilterSelection(filterName: string = "", selectedOptions: string[]) {
	const filterKey = filterName.replace(' ', '') as keyof typeof props.selectedFilters;

	// Update the selected filters with the entire array of selected options
	// let update = {...props.selectedFilters};
	// update[filterKey] = [...selectedOptions]
	// console.log( " FILTER KEY: ", filterKey)

	let update = {key: filterKey, selected: [...selectedOptions]}

	emit("update:filtersChange", update)
}

const onSectionClick = (isType:string="") => {

	emit("update:showFilters")
}


const __returned__ = { compareOrg, organizations, showLocation, selectedFilters, showFilters, emit, props, handleClearFilters, handleClick, handleFilterSelection, onSectionClick, ref, computed, watch, get useOrganizations() { return useOrganizations }, FilterSection, get elasticlunr() { return elasticlunr }, get SearchResults() { return SearchResults }, get Index() { return Index }, get debounce() { return debounce }, get filter() { return filter }, onMounted, get filterOrganizations() { return filterOrganizations }, get filtersBase() { return filtersBase } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})